import { render, staticRenderFns } from "./SalesPerWeekItemTable.vue?vue&type=template&id=da45e324&"
import script from "./SalesPerWeekItemTable.vue?vue&type=script&lang=js&"
export * from "./SalesPerWeekItemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports